import { api } from '../api';

export interface TenantVisibilitySettings {
  mode: 'branch' | 'context_only';
  adminBypass: boolean;
  actions: Record<string, 'creator_or_branch_descendant' | 'role_only'>;
}

export interface TenantMeResponse {
  id: number;
  slug: string;
  name: string;
  visibility?: TenantVisibilitySettings;
}

export const tenantsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getTenantMe: builder.query<TenantMeResponse, void>({
      query: () => '/tenants/me',
      providesTags: [{ type: 'Tenant', id: 'ME' }],
    }),
    updateTenantVisibility: builder.mutation<TenantVisibilitySettings, Partial<TenantVisibilitySettings>>({
      query: (body) => ({
        url: '/tenants/me/visibility',
        method: 'PATCH',
        body,
      }),
      invalidatesTags: [{ type: 'Tenant', id: 'ME' }],
    }),
  }),
});

export const {
  useGetTenantMeQuery,
  useUpdateTenantVisibilityMutation,
} = tenantsApi;
